module.exports = __webpack_public_path__ + "img/home_mfjy_label_icon@2x.09996530.png";